import React from 'react';
import PropTypes from 'prop-types';

class PrintBtn extends React.PureComponent {

  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    event.preventDefault();
    window.open(event.target.href, 'newwindow', 'width=1000,height=800');
  }

  render() {
    const {href, label, className} = this.props;
    return <a href={href} onClick={this.onClick} className={className}>{label}</a>
  };

}

PrintBtn.propTypes = {
  href: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
};

PrintBtn.defaultProps = {
  className: 'blue-pink-hover',
};

export default PrintBtn;
